/* eslint-disable consistent-return */
import { useEffect, useRef, useState } from 'react';
import { $alert } from 'signals/global.signals';
import { Toast, ToastContainer, ProgressBar } from 'react-bootstrap';

const Notifier = () => {
  const max = 100;
  const min = 0;
  const messages = (!Array.isArray($alert.value.message) ? [$alert.value.message] : $alert.value.message).filter(msg => !!msg);
  const show = messages.length > 0;
  const [progress, setProgress] = useState(max);
  const intervalRef = useRef(null);
  const interval = 60;
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    if (!show) {
      setProgress(max);
      setShowToast(false);
      return;
    }
    const timeout = $alert.value.timeOut || 2000;
    setProgress(max);
    setShowToast(true);
    const start = Date.now();

    intervalRef.current = setInterval(() => {
      const elapsed = Date.now() - start;
      const percent = Math.round(Math.max(0, 100 - (elapsed / timeout) * 100));
      setProgress(percent);

      if (elapsed >= timeout) {
        setProgress(0);
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        setTimeout(() => {
          setShowToast(false);
          $alert.reset();
        }, 200);
      }
    }, interval);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        setProgress(max);
      }
    };
  }, [show, $alert.value.timeOut]);

  const handleClose = () => {
    setProgress(0);
    setShowToast(false);
    $alert.reset();
  };

  return (
    <ToastContainer
      position="bottom-end"
      className="p-24"
    >
      <Toast
        show={showToast}
        onClose={handleClose}
        bg="dark"
      >
        <Toast.Header className="bg-dark" closeVariant="white">
          <strong className={`text-${$alert.value.variant}`}>{$alert.value.title || 'Notification'}</strong>
        </Toast.Header>
        <Toast.Body className="p-24 bg-gray-800">
          <ul className="p-0 m-0" style={{ listStyle: 'none' }}>
            {messages.map((msg, liidx) => <li key={`err-${liidx}`}>{msg}</li>)}
          </ul>
        </Toast.Body>
        <ProgressBar
          now={progress}
          min={min}
          max={max}
          style={{ height: 6, borderRadius: 0 }}
          variant={$alert.value.variant}
          className="mb-0"
        />
      </Toast>
    </ToastContainer>
  );
};

export default Notifier;
